export default __webpack_public_path__ + "static/media/18.d1421f63.svg";